import React, { useState } from 'react';
import styles from '../../styles/hardware/hardware.module.css';
import ReactTyped from 'react-typed';
import Image from 'next/image';
import { AdvanceAnalyticsBanner, AndroidPOSBenifits, BlackCustomButton, MarqueeComponentHomePage, TransparentCustomButton, WhiteCustomButton } from '../qbStrap';
import ThreeStepForm from '../common/ThreeStepForm';
import TestimonialSection from '../common/TestimonialSection';
import { ClientsArr1, softwareDevies, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import TrustFactor from '../common/TrustFactor';
import FrequentQuestions from '../homePage/FrequentQuestions';
import { softwareFaq } from '@/constants/industry';
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner';
import Link from 'next/link';
import { LuArrowUpRight } from "react-icons/lu";
import VerificationPopup from '../modals/VerificationPopup';
import { useRouter } from 'next/router';
import content from '../../language/ENGLISH.json';
import All from 'public/assets/software-partners/All';
import Accounting from 'public/assets/software-partners/Accounting';
import Loyalty from 'public/assets/software-partners/Loyalty';
import OnlineMarketplace from 'public/assets/software-partners/OnlineMarketplace';
import ERPSolutions from 'public/assets/software-partners/ERPSolutions';
import QuickCommerce from 'public/assets/software-partners/QuickCommerce';
import Sales from 'public/assets/software-partners/Sales';
import Others from 'public/assets/software-partners/Others';

const DesktopSoftware = () => {
    const [selectedDevice, setSelectedDevice] = useState(0);
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const router = useRouter();

    const { commonMarqueTitle } = getTitleContent();
    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section}>
                <div className={styles.text_container}>
                    <h1>
                        <span className={styles.small_black_text}>Extensive Software Integrations</span><br />
                        <span className={styles.black_text}>For Business </span><br /> <span className={styles.blue_text}><ReactTyped strings={["Growth", "Profitability"]} typeSpeed={200} loop /></span>
                    </h1>
                    <p className={styles.page_desc}>QueueBuster facilitates an array of leading software solutions, for businesses of all scales and sizes, with tailormade integrations at your fingertips.</p>
                    <div className={styles.btn_container}>
                        <BlackCustomButton text="Try it Free" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("14 Days free trial"))} />
                        <TransparentCustomButton text="Contact Sales" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("Contact Sales"))} />
                    </div>
                </div>
                <div className={styles.hero_img_container} style={{ width: "63rem" }}>
                    <div className={styles.hero_img}><Image src="/assets/software-partners/hero-img.webp" alt="hardware hero img" fill /></div>
                </div>
            </div>

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.all_devices} style={{ height: "125rem" }}>
                <div className={styles.stack1} style={{ height: "123rem" }}>
                    <div className={styles.choosing_section}>
                        <h3>Plug & Play Your Favorite Business Software</h3>
                        {
                            softwareDevies?.map((ele, idx) => {
                                return (
                                    <div key={ele?.id} onClick={() => setSelectedDevice(idx)} className={`${styles.device} ${selectedDevice === idx && styles.selected_device}`}>
                                        {
                                            ele?.device === "All Software" ?
                                                <All color={selectedDevice === idx ? "#2a6ab4" : "#fff"} /> :
                                                ele?.device === "Accounting Software" ?
                                                    <Accounting color={selectedDevice === idx ? "#2a6ab4" : "#fff"} /> :
                                                    ele?.device === "Loyalty & Rewards Software" ?
                                                        <Loyalty color={selectedDevice === idx ? "#2a6ab4" : "#fff"} /> :
                                                        ele?.device === "Online Marketplaces" ?
                                                            <OnlineMarketplace color={selectedDevice === idx ? "#2a6ab4" : "#fff"} /> :
                                                            ele?.device === "ERP Solutions" ?
                                                                <ERPSolutions color={selectedDevice === idx ? "#2a6ab4" : "#fff"} />
                                                                :
                                                                ele?.device === "Online Food Delivery" ?
                                                                    <QuickCommerce color={selectedDevice === idx ? "#2a6ab4" : "#fff"} />
                                                                    :
                                                                    ele?.device === "Sales Reporting" ?
                                                                        <Sales color={selectedDevice === idx ? "#2a6ab4" : "#fff"} />
                                                                        :
                                                                        <></>
                                        }
                                        <div>
                                            <h4>{`${ele?.device}`}</h4>
                                            <p>{ele?.desc}</p>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className={styles.device_container}>
                        {
                            softwareDevies[selectedDevice]?.deviceArr?.map((ele) => {
                                return (
                                    <div className={styles.hardware_device}>
                                        <div className={styles.hardware_device_img} style={{ height: ele?.height, width: ele?.width }}><Image src={ele?.image} alt={ele?.id} fill /></div>
                                        {/* <p>{ele?.deviceDesc.substring(0, 55)}...</p> */}
                                        <Link href={ele?.link} className={styles.navigtaion_link}>Learn More &nbsp;<LuArrowUpRight /></Link>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className={styles.stack2}></div>
                <div className={styles.stack3}></div>
            </div>

            <AndroidPOSBenifits setDemoModal={setDemoModal} setHeading={setHeading} />

            <div className={styles.good_hardware}>
                <div className={styles.text_section}>
                    <h4>Why Does Your Business Need a Software Integrated POS?</h4>
                    <ul className={styles.list_container}>
                        <li>Streamline sales processes and customer interactions.</li>
                        <li>Gain real-time insights and analytics for informed decision-making.</li>
                        <li>Improve collaboration and productivity to expand business.</li>
                        <li>Scale your business operations seamlessly with third party applications.</li>
                    </ul>
                </div>
                <div className={styles.hardware_img}><Image src="/assets/hardware/hardware.svg" alt="Android POS Software" fill /></div>
            </div>

            <AdvanceAnalyticsBanner setDemoModal={setDemoModal} setHeading={setHeading} />

            <div className={styles.why_qbPOS}>
                <div className={styles.text_section}>
                    <h4 className={styles.why_qbPOS_heading}>Why QueueBuster Stands Out as Your Ultimate Choice for Android POS Software?</h4>
                    <ul className={styles.list_container}>
                        <li>Robust Android POS solution for streamlined business operations.</li>
                        <li>Manage billing, inventory, sales, accounting, and CRM effortlessly within one system.</li>
                        <li>Enjoy a dual-screen setup for displaying customer carts and running targeted advertisements simultaneously.</li>
                        <li>Enhance customer satisfaction with features like self-ordering via table QR codes and seamlessly integrated KIOSK functionality.</li>
                    </ul>
                </div>
                <div className={styles.qbPOS_device}><Image src="/assets/hardware/why_qbPOS_device.webp" alt="Android POS Software" fill /></div>
            </div>

            <div style={{ margin: "0 9.3rem" }}><ThreeStepForm /></div>

            <div style={{ margin: "5rem 6rem" }}><TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /></div>
            <TrustFactor />

            <FrequentQuestions FaqTableData={softwareFaq} heading={"FAQs for Software Integrations with QueueBuster"} />
            <div style={{ margin: "0 9.3rem" }}><PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} /></div>
        </>
    )
}

export default DesktopSoftware